module.exports = "<div class=\"load3\">\n  <div class=\"loader\">\n  </div>\n</div>\n"